import * as React from 'react';
import { connect } from 'react-redux';
import { sortBy } from 'lodash';

import { removeAsset } from 'modules/campaigns/reducers/campaignAssets';

import CampaignAssetsGallery from './gallery/CampaignAssetsGallery';

import type { CampaignAsset } from 'types';

type OwnProps = {
  assets: Array<CampaignAsset>,
  canEdit: boolean
};

type DispatchProps = {
  dispatchRemoveAsset: (a: CampaignAsset) => Promise<void>
};

type Props = OwnProps & DispatchProps;

class CampaignAssets extends React.PureComponent<Props> {
  handleDeleteAsset = (asset: CampaignAsset) => {
    const { dispatchRemoveAsset } = this.props;

    dispatchRemoveAsset(asset);
  };

  render() {
    const { canEdit, assets } = this.props;

    return (
      <CampaignAssetsGallery
        assets={sortBy(assets, 'id')}
        canEdit={canEdit}
        onDeleteAsset={this.handleDeleteAsset}
      />
    );
  }
}

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchRemoveAsset: (asset: CampaignAsset) => dispatch(removeAsset(asset))
});

export default connect(null, mapDispatchToProps)(CampaignAssets);
